// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"da7fce25","108":"b9184a62","390":"4c080390","409":"70cf89c2","422":"885e73e1","508":"da16ae8d","775":"681153cc","900":"bd1239b7","939":"9593a1a8"}[chunkId] + ".chunk.js";
};